import { Component, Vue, Ref } from 'vue-property-decorator'
import { VNode } from 'vue'

@Component
export default class CreateForm extends Vue {
  @Ref() readonly dForm: any
  public schema: any = {}

  created() {
    this.schema = {
      properties: {
        name: {
          title: this.$t('page_docdirectory_name'),
          maxLength: 32,
          ui: {
            placeholder: this.$t('page_business_data_product_type_name_tip')
          }
        },
        description: {
          title: this.$t('page_business_data_description'),
          maxLength: 255,
          ui: {
            widget: 'textarea',
            placeholder: this.$t('page_business_data_product_type_description_tip')
          }
        }
      },
      required: ['name']
    }
  }

  render(): VNode {
    return <d-form schema={this.schema} ref="dForm"/>
  }
}
